import Queensberry2 from "../../../../src/components/RenderImgs/queensberryImgs1";
import * as React from 'react';
export default {
  Queensberry2,
  React
};